export default "__VITE_ASSET__PuoA5vEv__"